import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from "react-bootstrap";
import "../../../../assets/css/cms/Permission.css";
import { RiEdit2Line } from "react-icons/ri";
import { useSelector, useDispatch } from "react-redux";
import "../../../../assets/css/common/breadcrumb.css";
import {
    getFeedbackDetail, postFeedbackList, clearFeedbackDetailSuccess,
    putFeedbackDetail, putFeedbackMappedStatus,
} from "../../../../../store/slices/cp_feedback";
import DataTable from "react-data-table-component";
import CommonModal from "../../../utils/commonModal";
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../../constants/cms";
import { IoClose } from "react-icons/io5";

function FeedbackList(props) {
    const dispatch = useDispatch();
    const [id, setId] = useState([]);
    const [mappedTableData, setMappedTableData] = useState([]);
    const [unMappedTableData, setUnMappedTableData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [totalRows, setTotalRows] = useState(0);
    const [totalUnMappedRows, setTotalUnMappedRows] = useState(0);
    const [open, setOpen] = useState(false);
    const [tableCustomData, setTableCustomData] = useState([])
    const [moderated, setModerated] = useState(false);
    const [name, setName] = useState("");
    const [userImage, setUserImage] = useState(""); //store data from API
    const [feedback, setFeedback] = useState("");
    const [showError, setShowError]=useState(false);
    const [profileImage, setProfileImage] = useState(null); // store data on change
    const { date_to, date_from, product_id, feedback_type } = props.appliedFilters


    const { feedbackListData, postFeedbackListData, feedbackListLoading, feedbackDetailData,postFeedbackListLoading,putFeedbackDetailLoading,
        putFeedbackMappedStatusData, putFeedbackDetailData, feedbackListUnMappedData, feedbackListUnMappedLoading
    } = useSelector((state) => { return state?.cmsFeedback })

    function formatDate(inputDate) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        };

        const date = new Date(inputDate);
        return new Intl.DateTimeFormat('en-US', options).format(date);
    }

    const handleModeration = (e, row) => {
        if (props.addButtons) {
            setMappedTableData((prevData) => {
                return prevData.map((item) =>
                    item.cp_feedback_id === row.cp_feedback_id
                        ? { ...item, is_moderated: !item.is_moderated }
                        : item
                );
            })
        }
        else {
            setUnMappedTableData((prevData) => {
                return prevData.map((item) =>
                    item.cp_feedback_id === row.cp_feedback_id
                        ? { ...item, is_moderated: !item.is_moderated }
                        : item
                );
            })
        }
    }

    useEffect(() => {
        if (currentPage) {
            let params = {};
            params.page = currentPage;
            params.items_on_page = perPage;
            params.is_moderated = props.isModarate;
            if(feedback_type)
                params.feedback_type = feedback_type
            if(date_from)
                params.date_from = date_from;
            if (date_to) 
                params.date_to = date_to;
            if (product_id)
                params.product_id = product_id
            dispatch(props.feedbackState(params));
            setTableCustomData([
                {
                    name: "Mapped Status",
                    selector: (row) => row?.row?.is_moderated,
                    cell: (row, index, column, id) => (
                            props?.addButtons ?
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        className='feedback_checkbox'
                                        onChange={(e) => handleModeration(e, row)}
                                        checked={row?.is_moderated ? row?.is_moderated : moderated}
                                    ></Form.Check>
                                </Form.Group> :
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        className='feedback_checkbox'
                                        onChange={(e) => handleModeration(e, row)}
                                        checked={row?.is_moderated ? row?.is_moderated : moderated}
                                    ></Form.Check>
                                </Form.Group>
                            
                    ),
                    center: "true",
                    wrap:"true",
                },
                {
                    name: "Feedback Type",
                    selector: (row) => row?.feedback_type,
                    cell: (row, index, column, id) => (
                        row?.feedback_type
                    ),
                },
                {
                    name: "Date",
                    selector: (row) => formatDate(row?.created),
                    cell: (row, index, column, id) => (
                        row?.created
                    ),
                },
                {
                    name: "User Email",
                    selector: (row) => row?.user_data?.email,
                    cell: (row, index, column, id) => (
                        row?.user_data?.email
                    ),
                    minWidth: '200px',
                },
                {
                    name: "User Name",
                    selector: (row) => row?.user_name,
                    cell: (row, index, column, id) => (
                        row?.feedback_type === "actual" ? row?.user_data?.user_name : row?.custom_user_name
                    ),
                },
                {
                    name: "Feedback",
                    selector: (row) => row?.actual_feedback,
                    cell: (row, index, column, id) => (
                        <Form.Group>
                            <Form.Control as="textarea"
                                className='feedback_textarea'
                                value={row?.actual_feedback}
                            />
                        </Form.Group>
                    ),
                    wrap: true,
                    maxWidth: '300px',
                    minWidth: '300px',
                },
                {
                    name: "Edited Feedback",
                    selector: (row) => row?.custom_feedback,
                    cell: (row, index, column, id) => (
                        <Form.Group>
                            <Form.Control as="textarea"
                                className='feedback_textarea'
                                value={row?.custom_feedback}
                            />
                        </Form.Group>
                    ),
                    wrap: true,
                    maxWidth: '300px',
                    minWidth: '300px',
                },
                {
                    name: "Action",
                    selector: (row) => row?.action,
                    cell: (row, index, column, id) => (
                        <span className={"icon_edit"}
                            onClick={() => handleOpenModal("edit_feedback", row?.cp_feedback_id)}
                        >
                            <RiEdit2Line />
                        </span>
                    ),
                    allowOverflow: false,
                    center: "true",
                },
            ]);
        }
    }, [currentPage, props.appliedFilters]);

    useEffect(() => {

        if (postFeedbackListData || putFeedbackMappedStatusData || putFeedbackDetailData) {
            let params={};
            setOpen(false); 
            params.page = currentPage;
            params.items_on_page = perPage;
            params.is_moderated = props.isModarate;
            if (feedback_type)
                params.feedback_type = feedback_type;
            if (date_from)
                params.date_from = date_from;
            if (date_to)
                params.date_to = date_to;
            if (product_id)
                params.product_id = product_id;
            dispatch(props.feedbackState(params));
        }
    }, [postFeedbackListData, putFeedbackMappedStatusData, putFeedbackDetailData])
    
    useEffect(() => {
        if (feedbackListUnMappedData) {
            setUnMappedTableData(feedbackListUnMappedData?.results)
            setTotalUnMappedRows(feedbackListUnMappedData?.total_rows);
        }
    }, [feedbackListUnMappedData])

    useEffect(() => {
        if (feedbackListData) {
            setMappedTableData(feedbackListData?.results)
            setTotalRows(feedbackListData?.total_rows);
        }
        if (feedbackDetailData){
            setName(feedbackDetailData?.user_name);
            setUserImage(feedbackDetailData?.user_image);
            setFeedback(feedbackDetailData?.custom_feedback ? feedbackDetailData.custom_feedback : feedbackDetailData?.actual_feedback);
        }
    }, [feedbackListData, feedbackDetailData] )

    const handleUpdateList = (key) => {
        let feedbackData = []
        let body = {};
        if (key === "add_button") {
            feedbackData = mappedTableData
                .filter((item) => item.is_moderated !== 1)
                .map((item) => item.cp_feedback_id);
            body = {
                feedback_ids: feedbackData,
                is_moderated: 0,
            };
            dispatch(putFeedbackMappedStatus(body));

        }
        if (key === "edit_button") {
            feedbackData = unMappedTableData
                .filter((item) => item.is_moderated === true)
                .map((item) => item.cp_feedback_id);
            body = {
                feedback_ids: feedbackData,
                is_moderated: 1,
            };
            dispatch(putFeedbackMappedStatus(body))
        }
    }

   const handleCancel = ()=>{
       let params = {};
       params.page = currentPage;
       params.items_on_page = perPage;
       params.is_moderated = props.isModarate;
       if (feedback_type)
           params.feedback_type = feedback_type;
       if (date_from)
           params.date_from = date_from;
       if (date_to)
           params.date_to = date_to;
       if (product_id)
           params.product_id = product_id
       dispatch(props.feedbackState(params));
   }

    const handleSubmit = (str) => {
        const body = new FormData();
        let params={};
        
        if(feedback) body.append("custom_feedback", feedback);

            // in case of adding data
        if (str === "add_feedback"){
            body.append("user_name", name);
            body.append("created_by", props?.user?.id);
            body.append("product_id", product_id);
            if (userImage)
                body.append("user_image", userImage);
            if (name && feedback)
                dispatch(postFeedbackList(body));
        }

        // in case of editing data
        if (str === "edit_feedback") {
            if (feedbackDetailData?.feedback_type === "custom"){
                body.append("user_name", name);
                body.append("user_image", userImage);
            }
            body.append("updated_by", props?.user?.id);
            body.append("cp_feedback_id", id);
            body.append("is_moderated", parseInt(1));
            if (name && feedbackDetailData?.feedback_type === "custom" && feedback)
                dispatch(putFeedbackDetail( id,body ));
            if (feedbackDetailData?.feedback_type === "actual" && feedback)
                dispatch(putFeedbackDetail(id, body));
            if (putFeedbackDetailData && props.isModarate==0){
                params.page = currentPage;
                params.items_on_page = perPage;
                params.is_moderated = 1;
                if (feedback_type)
                    params.feedback_type = feedback_type;
                if (date_from)
                    params.date_from = date_from;   
                if (date_to)
                    params.date_to = date_to;
                if (product_id)
                    params.product_id = product_id;
                dispatch(props.feedbackState(params));
            }
            if (putFeedbackDetailData) handleModalClose();
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        let params = {};
        params.page = page;
        params.items_on_page = newPerPage;
        params.is_moderated = props.isModarate;
        if (feedback_type)
            params.feedback_type = feedback_type;
        if (date_from)
            params.date_from = date_from;
        if (date_to)
            params.date_to = date_to;
        if (product_id)
            params.product_id = product_id;
        dispatch(props.feedbackState(params));
        setPerPage(newPerPage);
    };

    const handleOpenModal = (str, id) => {
        if (str === "edit_feedback") {
            setOpen(true);
            dispatch(getFeedbackDetail(id))
            setId(id);
        }
        if (str === "add_feedback") {
            dispatch(clearFeedbackDetailSuccess());
            setName("");
            setUserImage(null);
            setFeedback("");
            setOpen(true);
        }
    }

    const handleModalClose=()=>{
        dispatch(clearFeedbackDetailSuccess());
        setOpen(false);
        setName("");
        setUserImage(null);
        setFeedback("");
        setId(null);
    }

    const isButtonDisabled = () => {
        const isInvalidName = !name && showError && feedbackDetailData?.feedback_type !== "actual";
        const isInvalidFeedback = !feedback && showError;
        const isFeedbackTooLong = feedback?.length >= 250;
        const isLoading = postFeedbackListLoading || putFeedbackDetailLoading;
    
        return isInvalidName || isInvalidFeedback || isFeedbackTooLong || isLoading;
    };


    return (
        <div className='block_user bg-white '>
            <Row>
                <Col>
                    <h4 className='m-4'>{props.heading}</h4>
                </Col>
            </Row>
            {props?.addButtons ?
                <Row>
                    <Col className='d-flex flex-row-reverse'>
                        <button
                            className={"exam_button "}
                            onClick={() => handleOpenModal("add_feedback")}
                        >
                            Add Custom
                        </button>
                    </Col>
                </Row>
                : <></>}

            {(mappedTableData || unMappedTableData) &&
                <Row>
                    <Col>
                        <div className={"exam_table_box cp_feedback_list"} style={{ marginTop: "20px" }}>
                            <DataTable
                                columns={tableCustomData}
                                customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                                data={props?.addButtons ? mappedTableData : unMappedTableData}
                                progressPending={props?.addButtons ? feedbackListLoading : feedbackListUnMappedLoading}
                                paginationPerPage={perPage}
                                pagination
                                paginationServer
                                onChangePage={handlePageChange}
                                paginationTotalRows={props?.addButtons ? totalRows : totalUnMappedRows}
                                onChangeRowsPerPage={handlePerRowsChange}
                            />
                        </div>
                    </Col>
                </Row>
            }

            <Row>
                <Col className='d-flex mx-4 my-4'>
                    <button className={
                        (props.isModarate == 0 ? !unMappedTableData?.length : !mappedTableData?.length)
                            ?"disabled_button exam_button":"exam_button"}
                        onClick={() => {
                            props?.addButtons ? (
                                handleUpdateList("add_button"))
                                :
                                handleUpdateList("edit_button");
                        }}
                        disabled={props.isModarate == 0 ? !unMappedTableData?.length : !mappedTableData?.length}
                    >
                        Save
                    </button>
                    <button className={
                        (props.isModarate == 0 ? !unMappedTableData?.length : !mappedTableData?.length)
                        ?"disabled_button exam_button":"exam_button"} 
                        disabled={props.isModarate == 0 ? !unMappedTableData?.length : !mappedTableData?.length}
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                </Col>
            </Row>

            {/* ******************************POPUP(COMMON MODAL)*************************** */}
           
            <CommonModal
                
                isOpen={open}
                closeOnOverlayClick={true}
                closeModal={() => {
                    handleModalClose();
                }}
                classNames={{
                    root: "feedback_modal",
                    modal: 'custom_modal',
                }}
            >
                <div className='modal_popup'>
                    <h2>Add/Edit Custom Feedback</h2>
                    <div classNames="feedback_popup_form_cover">

                    <Form>
                        {feedbackDetailData?.feedback_type != "actual" ?
                            <Row className='mt-4'>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>User Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder='Add User Name'
                                            maxLength={80}
                                            onFocus={()=>setShowError(true)}
                                            // autoFocus={"off"}
                                            className={feedbackDetailData?.feedback_type === "actual" && "disabled_field"}
                                            value={feedbackDetailData && name }
                                            onChange={(e) => setName(e.target.value)}
                                            disabled={feedbackDetailData?.feedback_type==="actual"}
                                        />
                                    {(!name && showError && feedbackDetailData?.feedback_type !="actual" )&& (
                                        <div className="error">This field is required</div>)
                                        }
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Upload Profile Image</Form.Label>
                                        <Form.Control
                                            name="image_web"
                                            type="file"
                                            className={feedbackDetailData?.feedback_type === "actual" && "disabled_field"}
                                            onChange={(e) => {
                                                setUserImage(e.target.files[0]);
                                            }}
                                            disabled={feedbackDetailData?.feedback_type === "actual"}
                                        />
                                    {(userImage)&& <div className='d-flex my-1'>
                                        <a href={feedbackDetailData?.user_image} target='_blank'>Profile Image </a>
                                        {feedbackDetailData?.feedback_type === "custom" &&  <span className='cross_icon' onClick={() =>  setUserImage(null)}><IoClose /></span>} </div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            :<></>
                        }
                        <Row className='mt-4'>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        as="textarea"
                                        maxLength={250}
                                        rows={5}
                                        onFocus={() => setShowError(true)}
                                        placeholder="Feedback..."
                                        className={"input_pd"}
                                        value={feedback|| ""}
                                        onChange={(e) => { setFeedback(e.target.value) }}
                                    />
                                    {(!feedback && showError) &&
                                        <div className="error">This field is required</div>
                                    }
                                    {(feedback?.length>=250) &&
                                        <div className="error">Char Limit: 250</div>
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col md={6}>
                                <div className='d-flex justify-content-between'>
                                    <button
                                        type="button"
                                        className={`exam_button ${isButtonDisabled() ? 'disabled_button' : ''}`}
                                        onClick={() => handleSubmit(feedbackDetailData ? "edit_feedback" : "add_feedback")}
                                        disabled={isButtonDisabled()}
                                    >Save
                                    </button>
                                    <button
                                        type="button"
                                        className="exam_button"
                                        onClick={() => handleModalClose()}
                                    >Cancel
                                    </button> 
                                </div>
                            </Col>
                        </Row>
                    </Form>
                    </div>

                </div>
            </CommonModal>

        </div>

    )
}

export default FeedbackList